import React, { Fragment } from 'react'
import { ButtonLink, Loader } from 'stylist'
import { Route, Switch } from 'react-router-dom'
import RouteShow from './show'
import Product from 'components/Product'
import ProductProvider from 'components/Product/Provider'
import Header from 'components/Header'

const RouteProduct = ({ match: { url, params }, location }) => (
  <ProductProvider variables={params}>
    <Product
      render={({ loading, product }) =>
        loading ? (
          <Loader size="lg" centered />
        ) : (
          <Fragment>
            <ButtonLink marginBottom to="/admin/products" size="sm">
              Back
            </ButtonLink>
            <Header>
              <div>
                <h3>{product.name}</h3>
              </div>
            </Header>
            <div>
              <Switch>
                <Route path={url} component={RouteShow} />
              </Switch>
            </div>
          </Fragment>
        )
      }
    />
  </ProductProvider>
)

export default RouteProduct



// WEBPACK FOOTER //
// ./src/routes/admin/products/product.js